import Payment from './Payment'

export default {
  Payment
}



// WEBPACK FOOTER //
// ./src/components/Payment/index.js